module.exports = __webpack_public_path__ + "img/sllr_JP.2a4faa63.jpg";